import React from "react";

import {
  Navigate,
} from "react-router-dom";

import BookingEngine from "../pages/BookingEngine/index";

import CabBooking from "../pages/BookingEngine/Components/CabBooking/CabBooking";
import ComingSoon from "../pages/BookingEngine/Components/ComingSoon"
const authProtectedRoutes = [];
const publicRoutes = [

  /* ===============================
     ROOT
  =============================== */

  {
    path: "/",

    component: (
      <Navigate
        to="/booking-engine"
        replace
      />
    ),
  },


  /* ===============================
     BOOKING ENGINE
  =============================== */

  {
    path: "/booking-engine",

    component:
      <BookingEngine />,
  },


  /* ===============================
     CAB BOOKING
  =============================== */

  {
    path: "/cabs",

    component:
      <CabBooking />,
  },


  /* ===============================
     UNKNOWN ROUTES
  =============================== */

  {
    path: "*",

    component: (
      <Navigate
        to="/booking-engine"
        replace
      />
    ),
  },

    {
    path: "/coming-soon",

    component:
      <ComingSoon />,
  },

];


export {
  authProtectedRoutes,
  publicRoutes,
};